export const CATEGORY_CONFIG_ORDER = 'CATEGORY_CONFIG_ORDER';
export const CATEGORY_CONFIG_USAGE = 'CATEGORY_CONFIG_USAGE';
export const COMPLIANCE_STATUS_COMPLIANT = 'COMPLIANT';

export const COMPLIANT_TOGGLE_BUTTON_CURRENT = 'CURRENT';
export const COMPLIANT_TOGGLE_BUTTON_COMPLIANT = 'COMPLIANT';

export const TEMPLATE_ERRORS_FILED_MISSING_REQUIRED_FIELD_VALUE = 'missingRequiredFields';

export const USAGE_OPTION_AT_LEAST_ONE_OPTION = 'ANY';
export const USAGE_OPTION_ALL_TEMPLATES = 'ALL';
export const USAGE_OPTION_OPTIONAL = 'OPTIONAL';

export const VIOLATION_LEVEL_ADMIN_ERROR = 'VIOLATION_LEVEL_ADMIN_ERROR';
export const VIOLATION_LEVEL_ADMIN_OVERRIDABLE = 'VIOLATION_LEVEL_ADMIN_OVERRIDABLE';
export const VIOLATION_LEVEL_PUBLISHER_ERROR = 'VIOLATION_LEVEL_PUBLISHER_ERROR';
export const VIOLATION_LEVEL_PUBLISHER_OVERRIDABLE = 'VIOLATION_LEVEL_PUBLISHER_OVERRIDABLE';
export const VIOLATION_LEVEL_NO_VIOLATION = 'VIOLATION_LEVEL_NO_VIOLATION';

export const ENTITY_PICKER_TYPE_CATEGORY = 'ENTITY_PICKER_TYPE_CATEGORY';
export const ENTITY_PICKER_TYPE_TEMPLATE = 'ENTITY_PICKER_TYPE_TEMPLATE';

export const getComplianceToggleOptions = (intl) => ([
  {
    name: intl.getI18nMessage('label.api.edit.policy.templates.compliant.status.current'),
    tooltip: intl.getI18nMessage('label.api.edit.policy.templates.compliant.current.tooltip'),
    uuid: COMPLIANT_TOGGLE_BUTTON_CURRENT,
  },
  {
    name: intl.getI18nMessage('label.api.edit.policy.templates.compliant.status.compliant'),
    tooltip: intl.getI18nMessage('label.api.edit.policy.templates.compliant.compliant.tooltip'),
    uuid: COMPLIANT_TOGGLE_BUTTON_COMPLIANT,
  },
]);
